/* eslint-disable comma-dangle */
export const SECTIONS = {
  BAÑO: 'Baño',
  DORMITORIO: 'Dormitorio',
  COCINA: 'Cocina',
  SALON: 'Salon',
  TERRAZA: 'Terraza',
  COMEDOR: 'Comedor'
};

export const SORT_OPTIONS = {
  price: 'Precio',
  productName: 'Nombre',
  section: 'Sección'
};

export const ADD_PRODUCT_INITIAL_STATE = {
  productName: '',
  description: '',
  price: '',
  section: ''
};

export const ELEMENTS_PER_PAGE = 6;
export const MINIMUM_PAGE = 1;

export const UPLOADPRESET = 'flat101';
